import * as surveyApi from "./api";
import * as constants from "./constants";
import { serializeAnswers } from "./answerHelpers";
import storage from "general/poly/storage";

const isPresent = () => {
  return JSON.parse(storage.sessionStorage.getItem(constants.STORAGE_KEYS.data));
};

const get = async (workplace, patientGroup, type) => {
  let resp = await surveyApi.getSurveyByWorkplace(workplace, type);

  if (resp.meta.total_count && resp.objects[0].questions.length ) {
    return resp.objects[0]
  }

  resp = await surveyApi.getSurveyByPatientGroup(patientGroup, type);
  
  if (resp.meta.total_count && resp.objects[0].questions.length) {
    return resp.objects[0]
  }

  return null
};

const save = async ({ appointmentId }) => {
  const id = JSON.parse(storage.sessionStorage.getItem(constants.STORAGE_KEYS.id));
  const data = JSON.parse(storage.sessionStorage.getItem(constants.STORAGE_KEYS.data));

  if (id && data && appointmentId) {
    const answers = serializeAnswers(data);
    if (answers.results.length) {
      await surveyApi.submitSurvey(id, appointmentId, answers);
    }
  }

  // clear
  storage.sessionStorage.removeItem(constants.STORAGE_KEYS.id);
  storage.sessionStorage.removeItem(constants.STORAGE_KEYS.data);
};

export { isPresent, get, save };
